import type { JSX } from 'react'
import type { IDropdownItemsGroupProps } from '../DropdownItemsGroup'

import { DropdownItemsGroup } from '../DropdownItemsGroup'
import { DropdownItemsGroupPaddings } from '../DropdownItemsGroup.h'

export interface IDropdownItemsGroupSettingsProps extends IDropdownItemsGroupProps {}

export const DropdownItemsGroupSettings = ({
  children,
  paddings = DropdownItemsGroupPaddings.SIZE_30,
  ...rest
}: IDropdownItemsGroupSettingsProps): JSX.Element => (
  <DropdownItemsGroup paddings={paddings} {...rest}>
    {children}
  </DropdownItemsGroup>
)
